import { render, staticRenderFns } from "./NavExpandedButtons.vue?vue&type=template&id=837391a6&scoped=true&"
import script from "./NavExpandedButtons.vue?vue&type=script&lang=js&"
export * from "./NavExpandedButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837391a6",
  null
  
)

export default component.exports